<div #panelcontainer class="minclt-panel">
    <section #leftpanel class="minclt-leftpanel">
        <div class="container-leftpanel">
            <ng-content select="[leftpanel]"></ng-content>
        </div>
    </section>
    <section #rightpanel class="minclt-rightpanel" [ngClass]="{ 'h-full': !enableAutoResize }">
        <ng-container *ngIf="showRightPanel">
            <div class="container-rightpanel">
                <ng-content select="[rightpanel]"></ng-content>
            </div>
        </ng-container>
    </section>
</div>